import React, { useState, useEffect, useRef } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MainWrapper from "../layouts/MainWrapper";
import CardWrapper from "../layouts/CardWrapper";
import Image from "react-bootstrap/Image";
import PageTitle from "../components/PageTitle";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import { getSupportSessions } from "../services/supportService";
import { createCall } from "../services/callServices";
import CalendarDetailsPanel from "../components/DetailsPanel/CalendarDetailsPanel";
import { useAlert } from "../contexts/AlertContext";
import { useAtom } from "jotai";
import { authAtom } from "../states/auth";
import ScheduleSidebar from "./ScheduleSidebar";
import scrollIntoView from "scroll-into-view-if-needed";
import { useNavigate } from "react-router-dom";
import { vonageAccessToken } from "../services/vonageServices";
import eventBus from "../utils/eventBus";
import { singleUser } from "../services/userService";
import moment from "moment";

const formatDate = (date) => {
  if (!date) return "From - To Date";
  return moment(date).format("YYYY-MM-DD");
};

const toUTCStartOfDay = (date) => {
  if (!date) return null;
  return moment(date).startOf("day").toISOString();
};

const toUTCEndOfDay = (date) => {
  if (!date) return null;
  return moment(date).endOf("day").add(1, "day").toISOString();
};

const getTodayRange = () => {
  const today = new Date();
  return { from: today, to: today };
};

const getThisWeekRange = () => {
  const start = moment().startOf("isoWeek").toDate();
  const end = moment().endOf("isoWeek").toDate();
  return { from: start, to: end };
};

const getThisMonthRange = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return { from: start, to: end };
};

const isSameDate = (d1, d2) => d1.toDateString() === d2.toDateString();

const getHourMinuteDiffString = (date1, date2) => {
  const start = moment(date1);
  const end = moment(date2);
  const duration = moment.duration(end.diff(start));
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};

function evaluateSessionTiming(startDateUTC, endDateUTC, isChat) {
  if (isChat === true) {
    return {
      isFutureSession: false,
      isPastSession: false,
      isSessionInWhile: false,
      isCurrentSession: false,
    };
  }

  const now = moment();
  const startDate = moment(startDateUTC);
  const endDate = moment(endDateUTC);

  const isFutureSession = startDate.isAfter(now);
  const isPastSession = endDate.isBefore(now);
  const isCurrentSession = now.isBetween(startDate, endDate, null, "[]");

  const diffInMillis = startDate.diff(now);

  const isSessionInWhile = diffInMillis > 0 && diffInMillis <= 10 * 60 * 1000;

  return {
    isFutureSession,
    isPastSession,
    isSessionInWhile,
    isCurrentSession,
  };
}

const Calendar = () => {
  const supportTimerRef = useRef(null);
  const heartbeatRef = useRef(null);
  const lastNowRef = useRef(Date.now());
  const latestSupportDataRef = useRef(null);

  const HEARTBEAT_MS = 5000; // heartbeat check every 5s
  const DRIFT_TOLERANCE_MS = 2000; // if drift > 2s → reschedule
  const EXTRA_BUFFER_MS = 1000; // 1s safety buffer

  const initialRange = getThisWeekRange();
  const selectedItemRef = useRef(null);
  const [range, setRange] = useState(initialRange);
  const [selectedItem, setSelectedItem] = useState(null);
  const [supportList, setSupportList] = useState(null);
  const [NewSchedulePanel, setNewSchedulePanel] = useState(false);
  const [loginUserId, setLoginUserId] = useState(null);
  const navigate = useNavigate();
  const [showStatusTypeDropdown, setStatusTypeDropdown] = useState(false);
  const dateRefs = useRef({});
  const hasScrolled = useRef(false);
  // const [range, setRange] = useState({ from: null, to: null });
  const { showAlert } = useAlert();
  const BeadcrumbItems = [{ label: "Calendar", active: true }];
  const [auth] = useAtom(authAtom);

  const [filter, setFilter] = useState({
    no_of_result: 0,
    page: 0,
    startDate: toUTCStartOfDay(initialRange?.from),
    endDate: toUTCEndOfDay(initialRange?.to),
    sessionType: "all",
  });

  useEffect(() => {
    setFilter({ ...filter });
  }, []);

  useEffect(() => {
    selectedItemRef.current = selectedItem;
  }, [selectedItem]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSupportList((prev) => [...(prev || [])]);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const meetingLinkOpen = (event, callId, session) => {
    event.preventDefault();
    try {
      const callRequest = {
        roomName: callId,
        identifierName: auth?.user?.firstName + auth?.user?.lastName,
      };

      const data = vonageAccessToken(callRequest).then((resp) => {
        console.log("response", resp);
        localStorage.setItem("vonage_session_id", resp.sessionId);
        localStorage.setItem("vonage_token", resp.token);
        localStorage.setItem("vonage_cid", session?.id);
        localStorage.setItem("vonage_meetingId", callId);
        localStorage.setItem("token", auth?.token);
        navigate("/connect");

        // setChatMessages(prev => [...prev, newMsg]);
        // setMessage('');
        // setSelectedFile(null);
        // scrollToBottom();
      });
    } catch (error) {
      showAlert({
        title: "Chat Screen Notification",
        message: error?.response?.data?.message ?? "Something went wrong",
        variant: "danger",
      });
    }
  };

  const joinCallButton = async (event, session) => {
    if (session?.calls && session?.calls[0]?.id) {
      // alert(singleInboxItem?.calls && singleInboxItem?.calls[0]?.id);
      meetingLinkOpen(event, session?.calls[0]?.id, session);
      // setMeetingId(singleInboxItem?.calls && singleInboxItem?.calls[0]?.id);
    } else {
      const data = {
        conversationID: session?.id,
      };
      try {
        const callRequestData = await createCall(data);
        // alert(callRequestData?.data && callRequestData?.data?.id)
        meetingLinkOpen(event, callRequestData?.data?.id, session);
        // setMeetingId(callRequestData?.data && callRequestData?.data?.id);
      } catch (error) {
        showAlert({
          title: "Chat Notification",
          message: error?.response?.data?.message ?? "something went wrong",
          variant: "danger",
        });
      }
    }
  };

  const rowHandler = (item) => {
    setSelectedItem(item);
    document.body.classList.add("sidebar-collapsed");
  };

  const sessionStatusIdentify = (session) => {
    const chatType = session?.conversationType?.includes("chat") ? true : false;
    const now = new Date(); // local time
    const startDate = new Date(session?.startTime); // UTC input
    const endDate = new Date(session?.endTime); // UTC input

    if (session?.conversationStatus == "Assigned") {
      if (endDate > now) {
        return { type: "badge-green", text: "Confirmed" };
      } else {
        return { type: "badge-green", text: "Confirmed" };
      }
    } else if (session?.conversationStatus == "Pending") {
      if (startDate < now) {
        return { type: "badge-danger", text: "Expired" };
      } else {
        return { type: "badge-warning", text: "Pending" };
      }
    }
  };

  const identifyUser = (data, auth) => {
    let userMeta = { label: "", image: "", role: "" };
    const otherUser = data?.createdBy?.createdBy.id ?? data?.createdBy?.createdBy;
    if (data?.createdBy?.roleId == 3) {

      if (data?.conversationType == "internal call") {
        userMeta = {
          label: "Expert",
          role: "expert",
          image: "/images/user-circle-yellow.svg",
        };
      } else if (otherUser !== auth ) {
        userMeta = {
          label: "Contact",
          role: "client",
          image: "/images/user-circle-gear-blue.svg",
        };
      } else {
        userMeta = {
          label: "External Expert",
          role: "external_expert",
          image: "/images/user-circle-dashed-red.svg",
        };
      }
    } else if (data?.createdBy?.roleId == 5) {
      userMeta = {
        label: "Contact",
        role: "client",
        image: "/images/user-circle-gear-blue.svg",
      };
    } else if (data?.createdBy?.roleId == 2) {
      if (data?.createdBy?.createdBy === data?.createdBy?.id) {
        userMeta = {
          label: "User",
          role: "internal_user",
          image: "/images/user-circle-yellow.svg",
        };
      } else {
        userMeta = {
          label: "User",
          role: "external_user",
          image: "/images/user-circle-yellow.svg",
        };
      }
    }
    return userMeta;
  };
  useEffect(() => {
    singleUser(auth?.user?.id).then((response) => {
      if (response?.data?.user) {
        const UserData = response?.data?.user;
        let loginUserId =
          UserData?.roleId === 2 ? UserData?.id : UserData?.createdBy?.id;
        setLoginUserId(loginUserId);
      }
    });
  }, [auth?.user]);

  const changeFilterCriteriaByName = (name, value) => {
    console.log(name, value);
    filter[name] = value;
    setSupportList(null);
    setFilter({ ...filter });
  };

  const groupByDatesAndSort = (data, showAllDates = true) => {
    const grouped = {};

    // Generate keys based on LOCAL date
    let current = moment(filter?.startDate);
    const end = moment(filter?.endDate);

    if (showAllDates) {
      // Loop until current is after end
      while (current.isSameOrBefore(end, "day")) {
        const dateKey = current.format("YYYY-MM-DD");
        grouped[dateKey] = [];
        current.add(1, "days");
      }
    }

    data?.forEach((item) => {
      // Convert UTC API time to Local Moment object
      const itemTime = moment(item.startTime || item.createdAt);
      const dateKey = itemTime.format("YYYY-MM-DD");

      if (grouped[dateKey]) {
        grouped[dateKey].push(item);
      } else if (!showAllDates) {
        grouped[dateKey] = [item];
      }
    });
    return grouped;
  };

  const getSupportList = async () => {
    try {
      const data = await getSupportSessions(filter);
      const fetchedData = data?.data || [];
      setSupportList(fetchedData);
      scheduleNextSupportRefresh(fetchedData);

      const stillExists =
        selectedItem && fetchedData.some((item) => item.id === selectedItem.id);
      if (!stillExists) {
        setSelectedItem(null);
      }
    } catch (error) {
      console.error("Error fetching invitees:", error);
      showAlert({
        title: "Contact Access Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  useEffect(() => {
    heartbeatRef.current = setInterval(() => {
      const now = Date.now();
      const diff = now - lastNowRef.current;
      lastNowRef.current = now;

      if (Math.abs(diff - HEARTBEAT_MS) > DRIFT_TOLERANCE_MS) {
        console.log("Clock drift detected → rescheduling timers");
        if (supportTimerRef.current) clearTimeout(supportTimerRef.current);
        scheduleNextSupportRefresh(latestSupportDataRef.current);
      }
    }, HEARTBEAT_MS);

    return () => {
      if (heartbeatRef.current) clearInterval(heartbeatRef.current);
      if (supportTimerRef.current) clearTimeout(supportTimerRef.current);
    };
  }, []);

  const handleUpdateConversation = (data) => {
    console.log("Update support request:", data);

    setSupportList((prevList) => {
      const exists = prevList?.some((item) => item.id === data.id);

      const newList = exists
        ? prevList.map((item) => (item.id === data.id ? data : item))
        : [data, ...(prevList || [])];

      // Reschedule timers with updated list
      scheduleNextSupportRefresh(newList);

      return newList;
    });

    if (selectedItemRef.current?.id == data.id) {
      setSelectedItem(data);
    }
  };

  const removeConversationById = (data) => {
    setSupportList((prev) => {
      const removedItem = prev.find((item) => item.id === data?.id);
      const updatedList = prev.filter((item) => item.id !== data?.id);
      console.log("Removed:", removedItem);

      // Reschedule timers with updated list
      scheduleNextSupportRefresh(updatedList);

      return updatedList;
    });

    if (selectedItemRef.current?.id == data.id) {
      setSelectedItem(null);
    }
  };

  useEffect(() => {
    eventBus.on("ACCEPT_REQUEST", handleUpdateConversation);
    eventBus.on("RESCHEDULED_REMOVE_EVENT", removeConversationById);
    eventBus.on("END_SUPPORT_REQUEST", removeConversationById);
    eventBus.on("RESCHEDULED_UPDATE_EVENT", handleUpdateConversation);

    return () => {
      eventBus.off("ACCEPT_REQUEST", handleUpdateConversation);
      eventBus.off("RESCHEDULED_REMOVE_EVENT", removeConversationById);
      eventBus.off("END_SUPPORT_REQUEST", removeConversationById);
      eventBus.off("RESCHEDULED_UPDATE_EVENT", handleUpdateConversation);
    };
  }, []);

  useEffect(() => {
    if (!filter) return;

    getSupportList();
  }, [filter]);

  // useEffect(() => {
  //   getSupportList();
  // }, []);

  useEffect(() => {
    latestSupportDataRef.current = supportList;

    if (!supportList || hasScrolled.current) return;

    const todayStr = formatDate(new Date());
    const allDates = Object.keys(groupByDatesAndSort(supportList));

    const scrollToDate = allDates.includes(todayStr) ? todayStr : allDates[0];

    const el = dateRefs.current[scrollToDate];

    if (el) {
      scrollIntoView(el, {
        behavior: "smooth",
        scrollMode: "if-needed",
        block: "start",
        inline: "nearest",
      });
      hasScrolled.current = true; // Mark as scrolled to prevent future scrolls
    }
  }, [supportList]);

  const isTodaySelected = () => {
    const today = new Date();
    return isSameDate(range.from, today) && isSameDate(range.to, today);
  };

  const isThisWeekSelected = () => {
    const { from, to } = getThisWeekRange();
    return isSameDate(range.from, from) && isSameDate(range.to, to);
  };

  const isThisMonthSelected = () => {
    const { from, to } = getThisMonthRange();
    return isSameDate(range.from, from) && isSameDate(range.to, to);
  };

  const isToday = (from, to) => {
    const today = new Date();
    return (
      from?.toDateString() === today.toDateString() &&
      to?.toDateString() === today.toDateString()
    );
  };

  const isThisWeek = (from, to) => {
    const now = new Date();
    const firstDayOfWeek = new Date(now);
    firstDayOfWeek.setDate(now.getDate() - now.getDay());
    firstDayOfWeek.setHours(0, 0, 0, 0);

    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
    lastDayOfWeek.setHours(23, 59, 59, 999);

    return (
      from?.toDateString() === firstDayOfWeek.toDateString() &&
      to?.toDateString() === lastDayOfWeek.toDateString()
    );
  };

  const isThisMonth = (from, to) => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    return (
      from?.toDateString() === firstDay.toDateString() &&
      to?.toDateString() === lastDay.toDateString()
    );
  };

  const scheduleNextSupportRefresh = (list) => {
    if (!list || list.length === 0) {
      if (supportTimerRef.current) clearTimeout(supportTimerRef.current);
      return;
    }

    const now = Date.now();
    let nextBoundary = null;

    list.forEach((item) => {
      const start = item.startTime ? new Date(item.startTime).getTime() : null;
      const end = item.endTime ? new Date(item.endTime).getTime() : null;

      if (start && start > now) {
        if (!nextBoundary || start < nextBoundary) nextBoundary = start;
      }
      if (end && end > now) {
        if (!nextBoundary || end < nextBoundary) nextBoundary = end;
      }
    });

    if (nextBoundary) {
      const delay = Math.max(nextBoundary - now + EXTRA_BUFFER_MS, 0);

      if (supportTimerRef.current) clearTimeout(supportTimerRef.current);

      supportTimerRef.current = setTimeout(() => {
        console.log("Session boundary reached → refreshing");
        setSupportList((prev) => [...(prev || [])]); // force re-render
        scheduleNextSupportRefresh(latestSupportDataRef.current); // schedule again
      }, delay);
    }
  };

  useEffect(() => {
    if (range?.from || range?.to) {
      setSupportList(null);
      setFilter((prev) => ({
        ...prev,
        startDate: toUTCStartOfDay(range.from),
        endDate: toUTCEndOfDay(range.to),
      }));
    }
    console.log("filterAaA", filter);
  }, [range]);

  const [tick, setTick] = useState(0);

  // Tick every second or 30 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTick((prev) => prev + 1); // triggers re-render
    }, 1000); // 1 second, adjust as needed

    return () => clearInterval(timer);
  }, []);

  const sessionLabelMap = {
    all: "Sessions",
    client: "Received",
    internal_user: "Internal",
    external_expert: "Requested",
  };
  return (
    <>
      <Row className="align-items-end justify-content-between mb-4">
        <Col lg="7">
          <CustomBreadcrumb items={BeadcrumbItems} />
          <PageTitle title="Calendar" />
        </Col>
        <Col lg="5" className="text-end">
          <Button
            as="button"
            variant="primary"
            className="btn btn-md d-inline-flex align-items-center justify-content-end gap-1"
            onClick={() => setNewSchedulePanel(true)}
          >
            <Image
              src="/images/calendar-plus-white.svg"
              width={20}
              height={20}
              alt="Calendar Plus White Icon"
            />
            Schedule
          </Button>
        </Col>
      </Row>
      <MainWrapper>
        <CardWrapper className="p-0">
          <div className="p-3 border-bottom">
            <Row className="align-items-center gy-2">
              <Col lg="12">
                <div className="d-flex align-items-center justify-content-between gap-4">
                  <h2 className="fs-5 fw-semibold text-gray-800 mb-0">
                    My Meetings
                  </h2>
                  <div className="d-flex flex-wrap align-items-center  gap-2">
                    <Dropdown
                      show={showStatusTypeDropdown}
                      onToggle={(isOpen) => setStatusTypeDropdown(isOpen)}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        className="filter-dropdown-button dropdown-toggle-arrow"
                        align="end"
                      >
                        {sessionLabelMap[filter.sessionType] || "Sessions"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        className="filter-dropdown-menu dropdown-menu-end p-0"
                        align="end"
                        popperConfig={{
                          modifiers: [
                            {
                              name: "offset",
                              options: { offset: [0, 5] },
                            },
                          ],
                        }}
                      >
                        <div className="px-2 pt-2 border-bottom">
                          <Form.Check
                            className="radio-primary mb-2"
                            type="radio"
                            label="Select All"
                            value="all"
                            checked={filter.sessionType === "all"}
                            onChange={() =>
                              changeFilterCriteriaByName("sessionType", "all")
                            }
                            id="radio-all"
                          />
                        </div>
                        <div className="px-3 py-2 border-bottom">
                          <Form.Check
                            className="radio-primary mb-3"
                            type="radio"
                            label="Received"
                            value="client"
                            onChange={() =>
                              changeFilterCriteriaByName(
                                "sessionType",
                                "client",
                              )
                            }
                            checked={filter.sessionType === "client"}
                            id="radio-clients"
                          />
                          <Form.Check
                            className="radio-primary mb-3"
                            type="radio"
                            label="Internal"
                            value="internal_user"
                            onChange={() =>
                              changeFilterCriteriaByName(
                                "sessionType",
                                "internal_user",
                              )
                            }
                            checked={filter.sessionType === "internal_user"}
                            id="radio-internal-users"
                          />
                          <Form.Check
                            className="radio-primary mb-3"
                            type="radio"
                            value="external_expert"
                            checked={filter.sessionType === "external_expert"}
                            onChange={() =>
                              changeFilterCriteriaByName(
                                "sessionType",
                                "external_expert",
                              )
                            }
                            label="Requested"
                            id="radio-external-experts"
                          />
                        </div>
                        <div className="p-2 d-flex align-items-center justify-content-between">
                          <button
                            onClick={(e) => {
                              setStatusTypeDropdown(false);
                              changeFilterCriteriaByName("sessionType", "all");
                            }}
                            className="btn btn-xm btn-reset text-blue"
                          >
                            Reset
                          </button>
                          <button
                            onClick={() => setStatusTypeDropdown(false)}
                            className="btn btn-xm btn-blue"
                          >
                            Okay
                          </button>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown align="end">
                      <Dropdown.Toggle
                        as="button"
                        id="to-date"
                        className="filter-dropdown-button dropdown-toggle-calendar dropdown-toggle-none d-flex align-items-center justify-content-between gap-2"
                      >
                        {range?.from && range?.to
                          ? `${formatDate(range.from)} - ${formatDate(
                              range.to,
                            )}`
                          : "From - To Date"}

                        <Image
                          src="/images/calendar-dots.svg"
                          alt="Calendar Check Icon"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="calendar-dropdown-menu dropdown-menu dropdown-menu-end">
                        <DayPicker
                          mode="range"
                          selected={range}
                          onSelect={(event) => (
                            console.log("datechange", event),
                            setRange(event)
                          )}
                          // onDayClick={() => setShowCalendar(false)}
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="full-box p-3">
            {supportList && Object.keys(supportList).length === 0 && (
              <div className="session-item bg-white cursor-auto border-grey-300 d-flex align-align-items-center justify-content-center mb-3">
                <p className="d-flex align-items-center fs-16 fw-500 text-gray-400 text-center mb-0">
                  No Events Available
                </p>
              </div>
            )}
            {supportList &&
              Object.entries(groupByDatesAndSort(supportList))
                .sort(([dateA], [dateB]) => moment(dateA).diff(moment(dateB))) // SORT BY DATE KEY
                .map(
                  ([date, sessions]) =>
                    sessions.length > 0 && (
                      <div
                        className="session-item-group"
                        key={date}
                        ref={(el) => (dateRefs.current[date] = el)}
                      >
                        <p className="text-gray-500 fs-15 fw-semibold mb-2">
                          {moment(date).format("dddd, MMM D")}
                        </p>

                        {sessions
                          .sort((a, b) =>
                            moment(a.startTime).diff(moment(b.startTime)),
                          )
                          .map((session) => {
                            const userMeta = identifyUser(session, loginUserId);
                            const anotherMember =
                              session.conversationMembers?.find(
                                (e) => e.user_id != auth?.user?.id,
                              );
                            const sessionStatusBadge =
                              sessionStatusIdentify(session);
                            const chatType =
                              session?.conversationType?.includes("chat");
                            const sessionTimeStatus = evaluateSessionTiming(
                              session.startTime,
                              session.endTime,
                              chatType,
                            );

                            return (
                              <div
                                className={`session-item ${selectedItem?.id === session.id ? "active" : ""}`}
                                onClick={() => rowHandler(session)}
                                key={session.id}
                              >
                                <div className="session-info">
                                  <Image
                                    src={
                                      session.conversationType.includes("chat")
                                        ? "/images/chat-circle-text.svg"
                                        : "/images/video-camera.svg"
                                    }
                                    width={32}
                                    height={32}
                                    alt="Icon"
                                  />
                                  <p className="text-gray-700 fs-12 fw-semibold mt-2 mb-0">
                                    {moment(
                                      session.startTime || session.createdAt,
                                    ).format("h:mm A")}

                                    {session.startTime && session.endTime && (
                                      <span className="d-inline-block fw-normal ms-1">
                                        (
                                        {getHourMinuteDiffString(
                                          session.startTime,
                                          session.endTime,
                                        )}
                                        )
                                      </span>
                                    )}
                                  </p>
                                </div>
                                <div className="session-details col">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <h3 className="fs-18 fw-bold mb-1">
                                      {session?.createdBy?.roleId == 3 &&
                                        session?.createdBy?.createdBy !=
                                          session?.admin?.id}
                                      {anotherMember?.user?.companyName ||
                                        session?.admin?.companyName}
                                    </h3>
                                    <span
                                      className={
                                        "badge " + sessionStatusBadge?.type
                                      }
                                    >
                                      {sessionStatusBadge?.text}
                                    </span>
                                  </div>
                                  <p className="fs-14 fw-medium text-gray-600 mb-0">
                                    {session?.expertise?.name || ""}
                                  </p>
                                  <ul className="d-md-flex align-items-md-center gap-2 list-unstyled mt-2 mb-0 justify-content-between">
                                    <span className="d-flex align-items-center gap-1 ">
                                      <li className="d-flex align-items-center gap-1">
                                        <Image
                                          src={
                                            userMeta?.image ||
                                            "/images/user-circle-gear-blue.svg"
                                          }
                                          width={20}
                                          height={20}
                                          alt="User"
                                        />
                                        <span className="fs-14 text-gray-500">
                                          {userMeta.label}:{" "}
                                          {userMeta.label === "External Expert"
                                            ? `${anotherMember?.user?.firstName || ""} ${anotherMember?.user?.lastName || ""}`.trim() ||
                                              "N/A"
                                            : `${anotherMember?.user?.firstName || ""} ${anotherMember?.user?.lastName || ""}`.trim() ||
                                              "N/A"}
                                        </span>
                                      </li>
                                      <li className="dot-separator"></li>
                                      {(anotherMember?.user?.firstName ||
                                        anotherMember?.user?.lastName) && (
                                        <li className="d-flex align-items-center gap-1">
                                          <Image
                                            src={
                                              "/images/user-circle-check-green.svg"
                                            }
                                            width={20}
                                            height={20}
                                            alt="Exp"
                                          />
                                          <span className="fs-14 text-gray-500">
                                            Expert:{" "}
                                            {auth?.user?.firstName || ""}{" "}
                                            {auth?.user?.lastName || ""}
                                          </span>
                                        </li>
                                      )}
                                    </span>

                                    {sessionStatusBadge?.text ===
                                      "Confirmed" && (
                                      <>
                                        {sessionTimeStatus?.isSessionInWhile && (
                                          <span className="btn meeting-chat-btn bg-white btn-icon rounded-3">
                                            <Image
                                              onClick={() =>
                                                navigate("/chat", {
                                                  state: {
                                                    singleInboxItem: session,
                                                  },
                                                })
                                              }
                                              src="/images/chat-circle-text-primary.svg"
                                              width={20}
                                              height={20}
                                            />
                                          </span>
                                        )}
                                        {sessionTimeStatus?.isCurrentSession && (
                                          <span className="d-flex align-items-center gap-1">
                                            <span className="btn meeting-chat-btn bg-white btn-icon rounded-3">
                                              <Image
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  joinCallButton(e, session);
                                                }}
                                                src={
                                                  "/images/video-camera-blue.svg"
                                                }
                                                width={20}
                                                height={20}
                                              />
                                            </span>
                                            <span className="btn meeting-chat-btn bg-white btn-icon rounded-3">
                                              <Image
                                                onClick={() =>
                                                  navigate("/chat", {
                                                    state: {
                                                      singleInboxItem: session,
                                                    },
                                                  })
                                                }
                                                src={
                                                  "/images/chat-circle-text-primary.svg"
                                                }
                                                width={20}
                                                height={20}
                                              />
                                            </span>
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    ),
                )}
          </div>
        </CardWrapper>

        <CalendarDetailsPanel
          item={selectedItem}
          setSupportList={setSupportList}
          isOpen={!!selectedItem}
          getSupportList={getSupportList}
          loggedInUser={auth}
          onClose={() => setSelectedItem(null)}
        />

        <ScheduleSidebar
          NewSchedulePanel={NewSchedulePanel}
          setNewSchedulePanel={setNewSchedulePanel}
          getCalenderList={getSupportList}
        />
      </MainWrapper>
    </>
  );
};

export default Calendar;
